<ng-container *ngIf="isLoadingOverlayDisplayed">
    <div class="loading-overlay">
        Loading...
    </div>
</ng-container>
<div #tableContainer class="table-container" [class.child-table]="isChildTable" [class.no-scroll-bars]="isLoadingOverlayDisplayed" [style.height]="tableHeight ? tableHeight : ''">
    <table #table [class.no-header]="!showColumnHeaders" [class.border-none]="!showColumnHeaders && filteredData.length === 0" [style.width]="isColumnSizeFixed ? 'max-content' : ''" *ngIf="filteredData != null && columnSettings.length > 0">
        <thead *ngIf="showColumnHeaders">
            <tr>
                <th class="row-details-column" *ngIf="hasRowDetails">&nbsp;</th>
                <th *ngIf="canSelectRows">
                    <input type="checkbox" class="checkbox-column" aria-label="Select all rows" [indeterminate]="selectedRowIds.length > 0 && selectedRowIds.length !== data.length" (change)="selectAllRows()" [checked]="selectedRowIds.length > 0" />
                </th>
                <ng-container *ngFor="let tableColumn of columnSettings | mcGetColumns">
                    <th [attr.aria-label]="tableColumn.title" class="ellipsis" [class.cell-max-width]="!isColumnSizeFixed" [class.sortable]="columnSortMode !== 'none' && tableColumn.canSort" [style.width]="isColumnSizeFixed ? tableColumn.width : ''" [attr.tabindex]="columnSortMode !== 'none' && tableColumn.canSort ? 0 : -1" (click)="onSortChange(tableColumn.propertyName)" (keydown)="onSortChange(tableColumn.propertyName)" *ngIf="tableColumn.dataType !== 'checkbox'">
                        <div [style.width]="isColumnSizeFixed ? tableColumn.width : ''">
                            {{ tableColumn.title }}
                            <ng-container *ngIf="tableColumn.propertyName | mcIsPropertySorted:sortSettings:updateTime">
                                <span [ngClass]="(tableColumn.propertyName | mcIsPropertySortDescending:sortSettings:updateTime) ? 'sort-descending' : 'sort-ascending'"></span>
                                <span *ngIf="columnSortMode === 'multiple' && sortSettings.length > 1" class="sort-order">{{ tableColumn.propertyName | mcGetSortOrder:sortSettings:updateTime }}</span>
                            </ng-container>
                        </div>
                        <span #columnResizer class="column-resizer" (mousedown)="resizeColumn(columnResizer, tableColumn.propertyName, $event)" *ngIf="canResizeColumns"></span>
                    </th>
                </ng-container>
            </tr>
            <tr *ngIf="isFilterEnabled">
                <td *ngIf="hasRowDetails">&nbsp;</td>
                <td *ngIf="canSelectRows">&nbsp;</td>
                <ng-container *ngFor="let tableColumn of columnSettings | mcGetColumns">
                    <td class="filter-cell" [class.cell-max-width]="!isColumnSizeFixed">
                        <input type="text" aria-label="Enter filter text" [(ngModel)]="tableColumn.filter" *ngIf="tableColumn.canFilter" (input)="onFilter()" />
                    </td>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="filteredData.length === 0">
                <tr class="no-data">
                    <td [attr.colspan]="columnCount" [class.border-none]="!showColumnHeaders">
                        <div>
                            No data
                        </div>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngFor="let dataItem of rowsForDisplay; let rowIndex = index">
                <tr [ngClass]="dataItem | mcGetRowClass:(rowIndex + 1)">
                    <ng-container *ngIf="hasRowDetails">
                        <td class="row-details-column" [class.row-selected]="dataItem[dataIDPropertyName] | mcIsRowSelected:selectedRowIds:updateTime">
                            <ng-container *ngIf="dataItem.hasRowDetails">
                                <button *ngIf="dataItem.isExpanded !== true" aria-label="Expand row" class="text-button" (click)="toggleRowExpandCollapse(dataItem)" (keydown)="toggleRowExpandCollapse(dataItem)">
                                    +
                                </button>
                                <button *ngIf="dataItem.isExpanded === true" aria-label="Collapse row" class="text-button collapse" (click)="toggleRowExpandCollapse(dataItem)" (keydown)="toggleRowExpandCollapse(dataItem)">
                                    -
                                </button>
                            </ng-container>
                        </td>
                    </ng-container>
                    <ng-container *ngIf="canSelectRows">
                        <td [class.row-selected]="dataItem[dataIDPropertyName] | mcIsRowSelected:selectedRowIds:updateTime">
                            <input type="checkbox" class="checkbox-column" aria-label="Select row" [checked]="dataItem[dataIDPropertyName] | mcIsRowSelected:selectedRowIds:updateTime" (change)="selectRow(dataItem[dataIDPropertyName])" />
                        </td>
                    </ng-container>
                    <ng-container *ngFor="let tableColumn of columnSettings | mcGetColumns">
                        <td [class.cell-max-width]="!isColumnSizeFixed" [class.row-selected]="dataItem[dataIDPropertyName] | mcIsRowSelected:selectedRowIds:updateTime" [ngClass]="tableCellWrapMode">
                            <ng-container *ngIf="tableColumn.dataType === 'button'">
                                <div *ngFor="let button of tableColumn.buttons; let buttonIndex = index">
                                    <button type="button" class="table-button" [class.button-spacing]="buttonIndex > 0" (click)="onButtonClick(dataItem, button.event)">{{ button.title }}</button>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="tableColumn.dataType === 'date' && tableColumn.dataFilter">
                                <div [style.max-width]="isColumnSizeFixed ? tableColumn.width : ''" [textContent]="dataItem[tableColumn.propertyName] | mcFormatDate:tableColumn['dataFilter']"></div>
                            </ng-container>
                            <ng-container *ngIf="tableColumn.dataType === 'html'">
                                <div class="vertical-scroll" [style.max-width]="isColumnSizeFixed ? tableColumn.width : ''" [innerHtml]="dataItem[tableColumn.propertyName]"></div>
                            </ng-container>
                            <ng-container *ngIf="tableColumn.dataType === 'string' || (tableColumn.dataType === 'date' && !tableColumn.dataFilter)">
                                <div [style.max-width]="isColumnSizeFixed ? tableColumn.width : ''">
                                    {{ dataItem[tableColumn.propertyName] }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="tableColumn.dataType === 'url'">
                                <div [style.max-width]="isColumnSizeFixed ? tableColumn.width : ''">
                                    <a href="{{ dataItem[tableColumn.propertyName] }}" target="_blank" rel="noopener">{{ dataItem[tableColumn.propertyName] }}</a>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
                <ng-container *ngIf="dataItem.isExpanded">
                    <tr class="row-details">
                        <td [attr.colspan]="columnCount">
                            <ng-template *ngTemplateOutlet="rowDetailsTemplate; context:{ $implicit: dataItem }"></ng-template>
                        </td>
                    </tr>
                </ng-container>
            </ng-container>
        </tbody>
        <ng-container *ngIf="showFooter">
            <tfoot>
                <tr>
                    <td class="row-details-column" *ngIf="hasRowDetails">&nbsp;</td>
                    <td *ngIf="canSelectRows">&nbsp;</td>
                    <ng-container *ngFor="let tableColumn of columnSettings | mcGetColumns">
                        <td class="ellipsis">
                            <div [style.max-width]="isColumnSizeFixed ? tableColumn.width : ''">
                                {{ tableColumn.footerText }}
                            </div>
                        </td>
                    </ng-container>
                </tr>
            </tfoot>
        </ng-container>
    </table>
</div>
